/* Her Collection — Customer Reviews — subtle motion
   Scroll reveal for Judge.me cards, which render after page load. */

(function () {
  'use strict';

  var root = document.querySelector('.hc-all-reviews--motion');
  if (!root) return;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function show(el) {
    el.classList.add('is-in');
  }

  var io = null;
  if (!reduced && 'IntersectionObserver' in window) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          show(entry.target);
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -6% 0px' });
  }

  function attach(card) {
    if (card.dataset.hcReveal) return;
    card.dataset.hcReveal = '1';
    var index = Array.prototype.indexOf.call(card.parentNode.children, card);
    card.style.setProperty('--hc-i', String(index % 3));
    if (io) io.observe(card);
    else show(card);
  }

  function scan() {
    root.querySelectorAll('.jdgm-review-card').forEach(attach);
  }

  scan();
  new MutationObserver(scan).observe(root, { childList: true, subtree: true });
})();
